/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_RbacInputs */

const en_svchip_rbac = /** @type {(inputs: Svchip_RbacInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RBAC`)
};

const ar_svchip_rbac = /** @type {(inputs: Svchip_RbacInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RBAC`)
};

const bn_svchip_rbac = /** @type {(inputs: Svchip_RbacInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RBAC`)
};

const de_svchip_rbac = /** @type {(inputs: Svchip_RbacInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RBAC`)
};

const es_svchip_rbac = /** @type {(inputs: Svchip_RbacInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RBAC`)
};

const fr_svchip_rbac = /** @type {(inputs: Svchip_RbacInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RBAC`)
};

const pt_svchip_rbac = /** @type {(inputs: Svchip_RbacInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RBAC`)
};

const zh_svchip_rbac = /** @type {(inputs: Svchip_RbacInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RBAC`)
};

const tr_svchip_rbac = /** @type {(inputs: Svchip_RbacInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RBAC`)
};

const ru_svchip_rbac = /** @type {(inputs: Svchip_RbacInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RBAC`)
};

const pl_svchip_rbac = /** @type {(inputs: Svchip_RbacInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RBAC`)
};

/**
* | output |
* | --- |
* | "RBAC" |
*
* @param {Svchip_RbacInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_rbac = /** @type {((inputs?: Svchip_RbacInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_RbacInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_rbac(inputs)
	if (locale === "bn") return bn_svchip_rbac(inputs)
	if (locale === "de") return de_svchip_rbac(inputs)
	if (locale === "es") return es_svchip_rbac(inputs)
	if (locale === "fr") return fr_svchip_rbac(inputs)
	if (locale === "pt") return pt_svchip_rbac(inputs)
	if (locale === "zh") return zh_svchip_rbac(inputs)
	if (locale === "tr") return tr_svchip_rbac(inputs)
	if (locale === "ru") return ru_svchip_rbac(inputs)
	if (locale === "pl") return pl_svchip_rbac(inputs)
	return en_svchip_rbac(inputs)
});